import {
  NEW_NOTIFICATION_MESSAGE,
  OPEN_NOTIFICATION,
  CLOSE_NOTIFICATION,
  SET_NOTIFICATION_SEVERITY,
} from '../constants/action-types'

export const newNotificationMessage = (message: any) => ({
  type: NEW_NOTIFICATION_MESSAGE,
  payload: message,
})
export const openNotification = (flag: any) => ({
  type: OPEN_NOTIFICATION,
  payload: flag,
})
export const closeNotification = (flag: boolean) => ({
  type: CLOSE_NOTIFICATION,
  payload: flag,
})
export const setNotificationSeverity = (severity: 'success' | 'error' | 'warning' | 'info') => ({
  type: SET_NOTIFICATION_SEVERITY,
  payload: severity,
})
